import { forwardRef } from "react";
import { func } from "prop-types";
import {
    MINIMIZE_BUTTON_ICON,
    MAXIMIZE_BUTTON_ICON,
    CLOSE_BUTTON_ICON,
} from "./constants";

const MinimizedButton = ({ isMinimized, setIsMinimized }) => {
    return (
        <button
            onClick={() => setIsMinimized(!isMinimized)}
            className={`${
                isMinimized ? "maximize" : "minimize"
            }-persistent-player-button`}
            aria-label={isMinimized ? "Maximize" : "Minimize"}
        >
            {isMinimized ? MAXIMIZE_BUTTON_ICON : MINIMIZE_BUTTON_ICON}
        </button>
    );
};

export const PersistentAudioUI = forwardRef(
    ({ onCloseClick, isMinimized, setIsMinimized }, ref) => {
        return (
            <div className="persistent-player-controls">
                <div className="persistent-player-view-controls">
                    <MinimizedButton
                        isMinimized={isMinimized}
                        setIsMinimized={setIsMinimized}
                    />
                    <button
                        onClick={onCloseClick}
                        className="close-persistent-player-button"
                        aria-label="Close player"
                        ref={ref}
                    >
                        {CLOSE_BUTTON_ICON}
                    </button>
                </div>
            </div>
        );
    }
);

export default PersistentAudioUI;

PersistentAudioUI.propTypes = {
    onCloseClick: func,
    setIsMinimized: func,
};
